import React from "react";
import propEq from "ramda/src/propEq";

import { L2Selector, L3Selector } from "../../common/network/NetworkSelectors";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { Grid } from "../../UI/Grid";

export const PlacementWorksheetUnitTypeSelector = () => {
  const { l2Id, setL2Id, setL3Id } = usePlacementWorksheetContext();

  const handleL2Change = (id: number) => {
    setL2Id(id);
    setL3Id(undefined);
  };

  const handleL3Change = (id: number) => {
    // First set the L3Id to trigger data loading
    setL3Id(id);
  };

  return (
    <Grid container spacing={2} sx={{ position: 'relative', zIndex: 20 }}>
      <Grid item>
        <L2Selector fullWidth onSelectHandler={handleL2Change} filter={propEq("placementWorksheetEnabled", true)} />
      </Grid>
      <Grid item>
        <L3Selector fullWidth l2Selection={l2Id} onSelectHandler={handleL3Change} />
      </Grid>
    </Grid>
  );
};
